export default {
  BOOKED_EVENTS: "events",
  ALL_EVENTS: "events/all_events",
};
